export enum SimulationGenerationStatus {
  Pending = 'PENDING',
  ProcessingDocuments = 'PROCESSING_DOCUMENTS',
  GenerationCoreSignal = 'GENERATION_CORE_SIGNAL',
  GenerationSectionPlan = 'GENERATION_SECTION_PLAN',
  GenerationDerivedComponent = 'GENERATION_DERIVED_COMPONENT',
  GenerationComponentWave1 = 'GENERATION_COMPONENT_WAVE_1',
  GenerationComponentWave2 = 'GENERATION_COMPONENT_WAVE_2',
  GenerationComponentWave3 = 'GENERATION_COMPONENT_WAVE_3',
  GenerationMessageAdherence = 'GENERATION_MESSAGE_ADHERENCE',
  Assembling = 'GENERATION_CONVERSE_PROMPT',
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  TokenLimitExceeded = 'TOKEN_LIMIT_EXCEEDED',
  // Refinement statuses (same underlying job-status column as CallRefinementServerStatus).
  // Added here for now so the simulations-list badge logic can reference them without
  // a separate import — see all-simulations-table.component.ts.
  RefinementRequested = 'REFINEMENT_REQUESTED',
  RefinementChangePlan = 'REFINEMENT_CHANGE_PLAN',
  RefinementSectionRewrite = 'REFINEMENT_SECTION_REWRITE',
  RefinementCompleted = 'REFINEMENT_COMPLETED',
  RefinementFailed = 'REFINEMENT_FAILED',
}
